import { Component, ElementRef } from '@angular/core'
import { Router } from '@angular/router'

import { AuthService,LocalizeService } from '../../insa-services'
import {SharedMethodsModule} from '../../insa-custom-scripts'

@Component({
  templateUrl: 'password-change.component.html'
})
export class ChangePasswordComponent {
  username: string = "";
  password: string = "";
  newPassword: string = "";
  confirmPassword: string = "";
  submitted: boolean = false;

  constructor(private _authService: AuthService, private _router: Router, private _localize: LocalizeService, private _element: ElementRef) { }

  cancelPasswordChange() {
    this._router.navigate(['/login']);
  }

  onSubmit(form: any): void {
    this.submitted = true;
    kendo.ui.progress($(".main-loading"), true);
    if (form['newPassword'] !== form['confirmPassword']) {
      kendo.ui.progress($(".main-loading"), false);
      SharedMethodsModule.addNotification("#notificationPassChange", this._localize.getTranslation('Lozinke nisu iste!'), false);
    } else {
      this._authService.changePassword(form["username"], form["password"], form['newPassword']);
    }
  }

  ngAfterViewInit () {
    this._localize.applyTranslations(this._element.nativeElement, 'LOOKUP'); // use the lookup table because translation service might not be available    
  }

}



// WEBPACK FOOTER //
// ./app/insa-components/insa-login/password-change.component.ts